export default __webpack_public_path__ + "static/media/food-placeholder.1eb77557.jpg";